export const notFoundText = {
  title: "Looks like you've stumbled upon a page that no longer exists.",
  info: "Sorry for the inconvenience. The page you're looking for may have been removed, or you might have entered an incorrect URL.",
  home: 'Home',
  help: 'Help',
  explore: 'Explore',
};
